import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Grid, Paper, TextField } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import CustomButton from '../layout/customButton/CustomButton';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import { isFirefox } from 'react-device-detect';
import { checkRolesAccessibilities } from '../../utils/checkRolesAccessibilities';

const PersonalCard = (props) => {
	const {
		styles,
		edit,
		previewImage,
		handleEdit,
		handleClickEdit,
		setOverlay,
		profileData,
		overlay,
		onOverlayClick,
		inputFile,
		onChangeImage,
		onChange,
		classes,
		fullName,
		email,
		phoneNumber,
		rolesAccessibilities,
		user,
	} = props;

	return (
		<Grid item xs={6}>
			<Paper className={styles.personal_card} data-testid='personalCard'>
				<div className={styles.profile_header}>
					<div className={styles.personal_title}>
						Personal information
					</div>

					{edit || previewImage ? (
						<CustomButton
							form='personal-form'
							type='submit'
							width={166}
							height={42}
						>
							Save Changes
						</CustomButton>
					) : (
						checkRolesAccessibilities(
							rolesAccessibilities,
							user.userType,
							'profile',
							'profile',
							0
						) && (
							<div
								className={styles.edit_btn}
								onClick={handleClickEdit}
							>
								<Edit />
							</div>
						)
					)}
				</div>

				<div className={styles.personal_content}>
					<div
						className={styles.profile_picture_circle}
						onMouseEnter={() => setOverlay(true)}
						onMouseLeave={() => setOverlay(false)}
					>
						<img
							src={
								previewImage
									? previewImage
									: profileData?.profilePicture
							}
							alt='Profile Picture'
							title='Profile Picture'
						/>
						{overlay && !isFirefox && (
							<div
								className={styles.profile_overlay}
								onClick={onOverlayClick}
							>
								<input
									type='file'
									id='file'
									ref={inputFile}
									onChange={onChangeImage}
									style={{ display: 'none' }}
									accept='image/png, image/gif, image/jpeg, image/jpg'
								/>
								<CameraAltIcon />
							</div>
						)}
					</div>
					<div className={styles.profile_header_info}>
						{edit || previewImage ? (
							<>
								<form
									id='personal-form'
									method='POST'
									onSubmit={handleEdit}
								>
									<TextField
										className={classes.textField}
										label='Full Name'
										name='fullName'
										autoComplete={'off'}
										type='text'
										value={fullName}
										onChange={(e) => onChange(e)}
										variant='outlined'
									/>
									<TextField
										className={classes.textField}
										label='Email'
										name='email'
										autoComplete={'off'}
										type='email'
										value={email}
										onChange={(e) => onChange(e)}
										variant='outlined'
									/>
									<TextField
										className={classes.textField}
										label='Phone Number'
										name='phoneNumber'
										autoComplete={'off'}
										type='text'
										value={phoneNumber}
										onChange={(e) => onChange(e)}
										variant='outlined'
									/>

									{isFirefox && (
										<Button
											variant='outlined'
											component='label'
											className={classes.textField}
										>
											Profile picture
											<input
												type='file'
												ref={inputFile}
												onChange={onChangeImage}
												accept='image/png, image/gif, image/jpeg, image/jpg'
												hidden
											/>
										</Button>
									)}
								</form>

								<Link
									to='/resetpassword'
									className={styles.link_text}
								>
									Reset Password
								</Link>
							</>
						) : (
							<>
								<p className={styles.label}>Full Name</p>
								<p className={styles.profile_small_text}>
									{profileData?.fullName}
								</p>
								<p className={styles.label}>Email</p>
								<p className={styles.profile_small_text}>
									{profileData?.email}
								</p>
								<p className={styles.label}>Phone Number</p>
								<p className={styles.profile_small_text}>
									{profileData?.phoneNumber}
								</p>
								{isFirefox && (
									<Button
										variant='outlined'
										component='label'
										className={classes.textField}
									>
										Profile picture
										<input
											type='file'
											ref={inputFile}
											onChange={onChangeImage}
											accept='image/png, image/gif, image/jpeg, image/jpg'
											hidden
										/>
									</Button>
								)}
								<Link
									to='/resetpassword'
									className={styles.link_text}
								>
									Reset Password
								</Link>
							</>
						)}
					</div>
				</div>
			</Paper>
		</Grid>
	);
};

export default PersonalCard;
